import React from "react";
import { Phone, ArrowRight, Zap, Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ProfessionalCleaningHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="39247" id="digitale-exzellenz-für-kmu" className="relative w-full py-24 md:py-32 overflow-visible bg-background text-foreground">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-[0.03] select-none overflow-hidden">
        <span className="text-[22px] font-bold text-[#0A1628]">Digital Caribe</span>
      </div>

      <div ref={ref} className={`relative z-10 max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center gap-12 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        {}
        <div className="flex-1 text-center lg:text-left">
          {}
          <div className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-sm font-semibold mb-6 bg-[#EEF2FF] text-[#3730A3] border border-[#E0E7FF] font-default">
            <Zap className="size-4" />
            <span>Mehr Kunden. Mehr Umsatz. Mehr Erfolg.</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-[56px] font-extrabold tracking-tight text-[#0A1628] mb-6 leading-[1.1] font-default">
            Professionelle Webseiten für Schweizer KMU
          </h1>

          <p className="text-lg md:text-xl text-[#4B5563] mb-10 max-w-[480px] mx-auto lg:mx-0 leading-relaxed font-default">
            Keine 5.000 CHF Agenturpreise. Keine monatelangen Wartezeiten. Ihre neue Webseite ist in 7–14 Tagen online — fertig, professionell und konversionsoptimiert.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mb-10">
            <Button asChild size="lg" className="w-full sm:w-auto bg-[#0A1628] text-white hover:bg-[#0A1628]/90 h-14 px-8 text-lg rounded-[8px] shadow-lg hover:shadow-xl transition-all font-default">
              <Link to="#pakete-festpreise">
                Pakete ansehen
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-2 border-[#0A1628] text-[#0A1628] hover:bg-[#0A1628]/5 bg-transparent h-14 px-8 text-lg rounded-[8px] transition-all font-default">
              <Link to="https://calendly.com/oscar-martinez-fontenla/30min" newTab>
                <Phone className="mr-2 size-5" />
                Kostenlose Beratung
              </Link>
            </Button>
          </div>

          {}
          <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 text-[14px] text-[#374151] font-default">
            <div className="flex items-center gap-1.5">
              <Check className="size-4 text-[#10B981]" />
              <span>Schweizer Unternehmen</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-border" />
            <div className="flex items-center gap-1.5">
              <Check className="size-4 text-[#10B981]" />
              <span>Lieferung in 7–14 Tagen</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-border" />
            <div className="flex items-center gap-1.5">
              <Check className="size-4 text-[#10B981]" />
              <span>Festpreis ohne Überraschungen</span>
            </div>
          </div>
        </div>

        {}
        <div className="flex-1 w-full max-w-2xl">
          <div className="relative rounded-[16px] overflow-visible shadow-2xl border border-border/50 bg-white group">
            <div className="h-8 bg-[#F9FAFB] border-b border-border/50 flex items-center px-4 gap-1.5">
              <div className="size-2.5 rounded-full bg-[#FF5F56]" />
              <div className="size-2.5 rounded-full bg-[#FFBD2E]" />
              <div className="size-2.5 rounded-full bg-[#27C93F]" />
            </div>
            <div className="relative">
              <Link to="http://brasa-del-caribe.10web.cloud/" newTab className="block transition-opacity duration-200 hover:opacity-85">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604926/img/image_v9njd8do.png" alt="Digital Caribe Web Design Mockup" className="w-full h-auto object-cover rounded-b-[15px]" />
              </Link>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none group-hover:pointer-events-auto bg-black/5 rounded-b-[15px]">
                <Button asChild className="bg-transparent text-white border-2 border-white hover:bg-white/10 h-12 px-6 rounded-[8px] shadow-2xl font-default transition-transform duration-300 scale-95 group-hover:scale-100">
                  <Link to="http://brasa-del-caribe.10web.cloud/" newTab>
                    Projekt ansehen
                    <ArrowRight className="ml-2 size-5" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}